export default {
    endereco: {}
}